export async function loadFontAsBase64(fontUrl) {
    const response = await fetch(fontUrl);
    const buffer = await response.arrayBuffer();
  
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
  
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
  
    return window.btoa(binary);
  }
  